<template>
  <div>
    <div class="video-slider-header">
        <p>{{ sectionData.field_1 }}</p>
    </div>
    <div class="video-slider-section">
      <div class="video-slider">
        <div class="main-slider" v-for="(slides, index) in videosChunk" :key="index" v-show="index === currentChunkIndex">
          <div class="slider-row">
            <div class="main-card" v-for="(slide, i) in slides" :key="i">
              <div class="card">
                <div class="top" @click="loadVideo(slide.field_4)">
                  <img class="card-image" :src="slide.field_3" alt="">
                  <img src="https://assets.rhinorack.com/StowIt/big-play-icon.png" alt="play button" class="play-icon">
                </div>
                <div class="card-details">
                  <p class="header">{{ slide.field_1 }}</p>
                  <p class="sub-header">{{ slide.field_2 }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="slider-controls">
        <div v-if="videosChunk.length > 1">
          <ul class="controls">
            <li @click="prevSlide" data-type="prev"></li>
            <li data-type="step" v-for="(slides, index) in videosChunk" :key="index"
              :class="index === currentChunkIndex ? 'active' : ''" @click="goToSlide(index)"></li>
            <li @click="nextSlide" data-type="next"></li>
          </ul>
        </div>
      </div>
    </div>

    <!-- Video Modal -->
    <div class="video-modal-background" v-if="isVideoModalOpen" @click="closeVideoModal">
      <div class="video-modal">
        <!-- <span class="close" @click="closeVideoModal">&times;</span> -->
        <iframe :src="videoUrl" frameborder="0" allowfullscreen></iframe>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "video-chunk-slider",
  props: {
    section: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      sectionData: {
        items: [],
      },
      slideOffset: 0,
      currentSlide: 0,
      chunk: 2,
      videosChunk: [],
      screenWidth: window.innerWidth,
      currentChunkIndex: 0,
      isVideoModalOpen: false,
      videoUrl: "",
    };
  },
  computed: {
    slideClass() {
      return this.chunk === 2 ? 'col-lg-6' : 'col-lg-12';
    },
  },
  mounted() {
    try {
      this.sectionData = JSON.parse(this.section);
    } catch (error) {
      console.error("Error parsing section JSON:", error);
    }
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    loadVideo(videoId) {
      this.videoUrl = `https://www.youtube.com/embed/${videoId}`;
      this.isVideoModalOpen = true;
    },
    chunkArr(arr, chunkSize) {
      if (chunkSize <= 0) {
        throw "Invalid chunk size";
      }
      let result = [];
      for (let i = 0, len = arr.length; i < len; i += chunkSize) {
        result.push(arr.slice(i, i + chunkSize));
      }
      return result;
    },
    nextSlide() {
      this.currentChunkIndex = (this.currentChunkIndex + 1) % this.videosChunk.length;
    },
    prevSlide() {
      this.currentChunkIndex = (this.currentChunkIndex - 1 + this.videosChunk.length) % this.videosChunk.length;
    },
    goToSlide(index) {
      this.currentChunkIndex = index;
    },
    handleResize() {
      this.screenWidth = window.innerWidth;
      if (this.screenWidth <= 767) {
        this.chunk = 1;
        this.videosChunk = this.chunkArr(this.sectionData.items, 1);
        this.currentChunkIndex = 0;
      } else {
        this.chunk = 2;
        this.videosChunk = this.chunkArr(this.sectionData.items, 2);
        this.currentChunkIndex = 0;
      }
    },
    closeVideoModal() {
      this.videoUrl = "";
      this.isVideoModalOpen = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.video-slider-header{
  color: #000000;
  font-family: 'trim-medium';
  font-size: 32px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 39px;
  text-align: center;
  padding-bottom: 66px;
  padding-top: 84px;

  @media only screen and (max-width: 767px) {
    font-size: 24px;
    padding-bottom: 47px;
    padding-top: 58px;
  }
}
.video-slider-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 15px;
  position: relative;
  padding-bottom: 35px;

  .video-slider {
    display: flex;
    justify-content: center;
    align-items: center;

    .main-slider {
      .slider-row {
        display: flex;
        flex-direction: row;
        gap: 20px;

        .main-card {
          .card {
            display: flex;
            flex-direction: column;
            gap: 15px;
            position: relative;

            .top {
              .card-image {
                height: 310.01px;
                width: 100%;
                object-fit: cover;
                border-radius: 8px;
                box-shadow: 0 2px 14px 0 rgba(0, 0, 0, 0.13)
              }

              .play-icon {
                position: absolute;
                top: 37%;
                left: 50%;
                transform: translate(-50%, -50%);
                width: 126px;
                height: 126px;
                cursor: pointer;
              }
            }

            .card-details {
              display: flex;
              flex-direction: column;

              .header {
                max-width: 551px;
                color: #000000;
                font-family: "trim-medium";
                font-size: 24px;
                font-weight: 500;
                letter-spacing: 0;
              }

              .sub-header {
                max-height: 48px;
                max-width: 537.19px;
                color: #000000;
                font-family: "trim-light";
                font-size: 18px;
                font-weight: 300;
                letter-spacing: 0.35px;
                line-height: 24px;
              }
            }
          }
        }
      }
    }
  }

  .slider-controls {
    .controls {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 2rem;
      padding-left: 0;
      flex-wrap: wrap;

      li {
        list-style-type: none;
        height: .8rem;
        width: .8rem;
        background-color: #D8D8D8;
        margin: .4rem;
        cursor: pointer;

        &.active {
          background-color: #005CB9;
        }

        &:first-child {
          background-color: transparent;
          border: solid #353535;
          border-width: 0 3px 3px 0;
          display: inline-block;
          width: 1rem;
          height: 1rem;
          transform: rotate(135deg);
          margin-right: 1rem;
        }

        &:last-child {
          background-color: transparent;
          border: solid #353535;
          border-width: 0 3px 3px 0;
          display: inline-block;
          width: 1rem;
          height: 1rem;
          transform: rotate(-45deg);
          margin-left: 1rem;
        }
      }
    }
  }


}
.video-modal-background {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.8);
    display: flex;
    justify-content: center;
    align-items: center;

    .video-modal {
      position: relative;
      width: 80%;
      max-width: 800px;
      background: #fff;
      border-radius: 8px;
      padding: 20px;

      .close {
        position: absolute;
        top: 10px;
        right: 10px;
        font-size: 24px;
        cursor: pointer;
      }

      iframe {
        width: 100%;
        height: 450px;
      }

    }

  }
</style>
